/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import axios from "axios";

export const useCustomReactQuery = (urlPath) => {
  //const userSessionContext = useContext(UserSessionContext);
  const [records, setRecords] = useState();
  const [error, setError] = useState(false);
  const [Loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
         const response = await axios.get(urlPath);
        //{
        //   headers: {
        //     Authorization: token,
        //     "Content-Type": "application/json",
        //   },
        //});
        if (response.data.status_code === 401) {
        //   userSessionContext.handleLogOut();
        return;
        } else if (response.data.status_code === 200) {
    
          setRecords(response.data.msg);
          setLoading(false);
        } else {
          toast.error("Error Loading");
          setError(true);
          setLoading(false);
        }
      } catch (error) {
        setError(true);
        toast.error("Cannot load data");
        setLoading(false);
      }
    })();
  }, []);
  return [records,  setRecords,error, Loading];
};
